(function () {
  'use strict';

  // Section chrome only. The carousel is driven by component-common-carousel.js;
  // this just triggers the header's scroll reveal.

  function init() {
    if (window.revealOnScroll) {
      window.revealOnScroll('.c-news-common-gallery', { threshold: 0.15 });
    }
  }

  document.addEventListener('DOMContentLoaded', init);
})();
